module.exports = __webpack_public_path__ + "assets/videos/SpokePromo-d2938564ef20e10abf757c09182a1056.mp4";